import React from "react";
import _ from "lodash";

import IColumn from "models/IColumn";
import { PictureAsPdf } from "components/Icons";
import { columns as invoicesColumns } from "../../invoices/columns";
import { columns as deliveriesColumns } from "../../deliveries/columns";
import { columns as receiptsReturnsColumns } from "../../receiptsReturns/columns";
import { downloadDocument } from "helpers/download";
import { getFormatted } from "helpers/formatting";
import { ROLE_IDS } from "constants/.";

export const orderLinesColumns: IColumn[] = [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 52,
    visible: true
  },
  {
    title: "QUANTITY",
    key: "Quantity",
    type: "number",
    visible: true
  },
  {
    title: "QUANTITY_UNIT",
    key: "QuantityUnit.Description",
    visible: true
  },
  {
    title: "DELIVERIED_QUANTITY",
    key: "ShippedQuantity",
    visible: true,
    render: ({ ShippedQuantity = 0, PendingQuantity = 0 }) =>
      getFormatted(ShippedQuantity + PendingQuantity, "number")
  },
  {
    title: "DELIVERIES_COMPLETE",
    key: "ShippedCompletely",
    type: "boolean",
    visible: true
  },
  {
    title: "ARTICLE_DESCRIPTION",
    key: "Item.Description",
    visible: true,
    render: rowData => rowData.Item.Description + rowData.GrowerClaims
  },
  {
    title: "SIZE",
    key: "ProductValue1.Description",
    visible: true
  },
  {
    title: "PRICE",
    key: "Price",
    render: rowData =>
      rowData.Price && ROLE_IDS[rowData.RoleId] !== "Supplier"
        ? getFormatted(rowData.Price, "currency")
        : "-",
    type: "currency",
    visible: true
  },
  {
    title: "PRICE_UNIT",
    key: "PriceUnit.Description",
    render: rowData =>
      ROLE_IDS[rowData.RoleId] === "Supplier"
        ? "-"
        : _.get(rowData.PriceUnit, "Description", "-"),
    visible: true
  },
  {
    title: "ORDERS_EX_BTW",
    key: "OrderedAmount",
    render: rowData =>
      rowData.OrderedAmount && ROLE_IDS[rowData.RoleId] !== "Supplier"
        ? getFormatted(rowData.OrderedAmount, "currency")
        : "-",
    type: "currency",
    visible: true
  },
  {
    title: "BIO",
    key: "Bio",
    type: "boolean",
    visible: true
  }
];

export const orderDeliveriesColumns = _.filter(
  deliveriesColumns,
  col => !_.includes(["checkbox"], col.key)
);

export const orderReceiptsReturnsColumns = _.filter(
  receiptsReturnsColumns,
  col => !_.includes(["checkbox"], col.key)
);

export const orderInvoicesColumns = _.filter(
  invoicesColumns,
  col => !_.includes(["Order.Number", "checkbox"], col.key)
);

export const orderVersionsColumns: IColumn[] = [
  {
    key: "pdf",
    isSortable: false,
    render: rowData => (
      <PictureAsPdf
        id={`download-order-${rowData.DocumentId}.pdf`}
        onClick={e => {
          e.stopPropagation();
          downloadDocument(rowData);
        }}
      />
    ),
    visible: true
  },
  {
    title: "ORDERS_NUMBER",
    key: "Order.Number",
    visible: true
  },
  {
    title: "VERSION",
    key: "VersionNumber",
    visible: true
  },
  {
    title: "ORDERS_VERSION_DATE",
    key: "Date",
    type: "date",
    visible: true
  }
];
